export const isValidPhoneNumber = (input: string) => {
  return (
    input.length > 9 &&
    input.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]\d{2}-?\d{4}$/)
  );
};
